import { useState, useEffect, FC } from "react";
import { AsyncAutocompleteField } from "@sainsburys-tech/luna-autocomplete";
import { AutoCompleteProps } from "../../Types/AutoCompleteProps";
import { loadAutoCompleteOptions } from "../../Service-Utils/autoCompleteHelper";

const AutoComplete: FC<AutoCompleteProps> = (props) => {
  const [initialValue, setInitialValue] = useState(props.initialValue || "");

  useEffect(() => {
    setInitialValue(props.initialValue);
  }, [props.initialValue]);

  return (
    <div data-testid="autocomplete-async-1">
      <AsyncAutocompleteField
        error={props.error}
        label={props.label}
        className={props.className}
        name={props.name}
        placeholder={props.placeholder}
        data-testid={props.testid}
        loadOptions={loadAutoCompleteOptions.bind(this, props.searchedProperty,
          initialValue, props.apiPath, props.selectedField, props.filter)}
        minChars={0}
        value={initialValue}
        onSelect={(e: any) => {
          if (e === null) {
            setInitialValue("");
            if (
              props.initialValue === null ||
              props.initialValue === "" ||
              props.initialValue === undefined
            ) {
              return "";
            }
          }
          props.onSelect(e);
        }}
        onChange={(e: any) => {
          setInitialValue(e.target.value);
        }}
      />
    </div>
  );
};

export default AutoComplete;
